import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["wunderkind", "Wunderkind Text"],
  iconColor: "#5CBF64", // alien
  getIcon(options) {
    return createIcon(
      `
      <path
        d="M14.21 8.47547C14.1891 8.38151 14.1717 8.29103 14.1717 8.23187C14.1717 8.04395 14.2274 7.89083 14.3387 7.7725C14.4501 7.65766 14.6102 7.59502 14.8224 7.58458V7.22266H10.156V7.58458C10.3613 7.58458 10.5075 7.67506 10.6675 7.81774C10.8241 7.96043 10.9529 8.16923 11.0573 8.42327L15.2574 18.5502H15.5984L16.966 15.2511L14.4014 9.07752C14.3213 8.88264 14.2552 8.68428 14.21 8.47547Z"
        fill="#010715"
      />
      <path
        d="M4.86304 7.22266V7.58458C5.06835 7.58458 5.2145 7.67506 5.37457 7.81774C5.53116 7.96043 5.65991 8.16923 5.76431 8.42327L9.96445 18.5502H10.3055L11.673 15.2511L8.33937 7.22266H4.86304Z"
        fill="#010715"
      />
      <path
        d="M17.6584 9.95804C18.4752 9.95804 19.1373 9.29586 19.1373 8.47902C19.1373 7.66218 18.4752 7 17.6584 7C16.8416 7 16.1794 7.66218 16.1794 8.47902C16.1794 9.29586 16.8416 9.95804 17.6584 9.95804Z"
        fill="#010715"
      />
      `,
      "#EFF9EF", // alien-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
